<template>
  <main class="main-container">
    <div class="card-panel consulta-card">

      <div class="page-title">
        Consulta de números
      </div>

      <div class="consulta-layout">

        <!-- IZQUIERDA -->
        <div class="entrada-container">

          <label for="numeros">
            Números telefónicos
          </label>

          <textarea
              id="numeros"
              v-model="numerosInput"
              class="numeros-input"
              placeholder="Pega aquí los números separados por comas&#10;&#10;5512345678, 5587654321, 5544443333"
          ></textarea>

          <div class="input-info">
            {{ numeros.length }} números detectados
          </div>

          <button
              class="waves-effect waves-light btn-large blue-grey darken-3 consultar-btn"
              :disabled="loading"
              @click="consultarNumeros"
          >
            <i class="material-icons left">
              search
            </i>

            {{ loading ? 'Consultando...' : 'Consultar' }}
          </button>

        </div>

        <!-- DERECHA -->
        <div class="resultados-container">

          <div class="resultados-header">

            <div>
              <h5>Resultados</h5>

              <span>
                {{ resultadosFiltrados.length }} resultados
              </span>
            </div>

            <input
                v-model="busqueda"
                type="text"
                class="busqueda-input"
                placeholder="Buscar número o estatus..."
            />

          </div>

          <div
              v-if="resultados.length === 0"
              class="sin-resultados"
          >
            <i class="material-icons">
              search
            </i>

            <p>
              Los resultados aparecerán aquí
            </p>
          </div>

          <div
              v-else
              class="tabla-container"
          >

            <table class="striped highlight">

              <thead>
              <tr>
                <th>Número</th>
                <th>Compañía</th>
                <th>HTTP</th>
                <th>Mensaje</th>
                <th>Estatus</th>
              </tr>
              </thead>

              <tbody>

              <tr
                  v-for="resultado in resultadosFiltrados"
                  :key="resultado.dn"
              >

                <td>
                  {{ resultado.dn }}
                </td>

                <td>
                  {{ resultado.companiaConsultada || '-' }}
                </td>

                <td>
                  {{ resultado.httpCode || '-' }}
                </td>

                <td>
                  {{ resultado.serviceMessage || '-' }}
                </td>

                <td>

                    <span
                        class="estatus"
                        :class="obtenerClaseEstatus(resultado.status)"
                    >
                      {{ resultado.status }}
                    </span>

                </td>

              </tr>

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </div>
  </main>
</template>

<script>
import { verificacionMasiva } from "@/api/api"
const MAX_DNS = 20
export default {
  name: "ConsultaNumeros",

  data() {
    return {
      numerosInput: "",
      numeros: [],
      resultados: [],
      busqueda: "",
      loading: false
    }
  },

  computed: {
    resultadosFiltrados() {
      const busqueda = this.busqueda
          .trim()
          .toLowerCase()

      if (!busqueda) {
        return this.resultados
      }

      return this.resultados.filter(resultado => {
        return (
            String(resultado.dn)
                .toLowerCase()
                .includes(busqueda) ||

            String(resultado.status)
                .toLowerCase()
                .includes(busqueda) ||

            String(resultado.companiaConsultada)
                .toLowerCase()
                .includes(busqueda) ||

            String(resultado.serviceMessage)
                .toLowerCase()
                .includes(busqueda)
        )
      })
    }
  },

  watch: {
    numerosInput(valor) {
      this.numeros = this.parsearNumeros(valor)
    }
  },

  methods: {

    parsearNumeros(valor) {
      return [
        ...new Set(
            valor
                .split(",")
                .map(numero => numero.trim())
                .filter(numero => numero.length > 0)
        )
      ]
    },

    async consultarNumeros() {

      this.numeros = this.parsearNumeros(
          this.numerosInput
      )

      if (!this.numeros.length) {

        M.toast({
          html: "Ingresa al menos un número",
          classes: "rounded",
          displayLength: 3000
        })

        return
      }
      if (this.numeros.length > MAX_DNS) {

        M.toast({
          html: `El máximo permitido es de ${MAX_DNS} números`,
          classes: "rounded",
          displayLength: 4000
        })

        return
      }

      this.loading = true
      this.resultados = []
      this.busqueda = ""

      try {

        /*
         * El backend espera una cadena:
         *
         * {
         *   dns: "5534316959,5530266025",
         *   idUser: 123
         * }
         */

        const dns = this.numeros.join(",")

        const response = await verificacionMasiva({
          dns })

        console.log("Respuesta backend:", response)

        this.resultados =
            response.resultados || []

        M.toast({
          html: `${this.resultados.length} números procesados`,
          classes: "rounded",
          displayLength: 3000
        })

      } catch (error) {

        console.error(
            "Error consultando números:",
            error
        )

        this.resultados = []

        M.toast({
          html: "No fue posible realizar la consulta",
          classes: "rounded",
          displayLength: 4000
        })

      } finally {

        this.loading = false

      }
    },

    obtenerClaseEstatus(status) {

      const valor = String(status)
          .toLowerCase()

      if (
          valor === "enrolado" ||
          valor === "success"
      ) {
        return "estatus-ok"
      }

      if (
          valor === "no_enrolado"
      ) {
        return "estatus-neutral"
      }

      if (
          valor.includes("error")
      ) {
        return "estatus-error"
      }

      return "estatus-neutral"
    }

  }
}
</script>

<style scoped>

* {
  box-sizing: border-box;
}

.main-container {
  width: 94%;
  margin: 0 auto;
}

.consulta-card {
  border-radius: 10px;
  padding: 25px;
}

.page-title {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.623);
  margin-bottom: 25px;
}

.consulta-layout {
  display: grid;
  grid-template-columns: 35% 65%;
  gap: 25px;
}

/* INPUT */

.entrada-container {
  display: flex;
  flex-direction: column;
}

.entrada-container label {
  font-size: 16px;
  color: #555;
  margin-bottom: 8px;
}

.numeros-input {
  width: 100%;
  height: 350px;
  resize: vertical;

  padding: 15px;

  border: 1px solid #ccc;
  border-radius: 6px;

  font-size: 15px;
  line-height: 1.6;

  outline: none;
}

.numeros-input:focus {
  border-color: #546e7a;
}

.input-info {
  color: #777;
  font-size: 13px;
  margin-top: 6px;
  margin-bottom: 15px;
}

.consultar-btn {
  width: 100%;
}

/* RESULTADOS */

.resultados-container {
  min-width: 0;
}

.resultados-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  margin-bottom: 15px;
}

.resultados-header h5 {
  margin: 0 0 5px 0;
}

.resultados-header span {
  color: #777;
  font-size: 13px;
}

.busqueda-input {
  width: 280px !important;
  margin: 0 !important;

  padding-left: 12px !important;

  border: 1px solid #ccc !important;
  border-radius: 5px !important;
}

.tabla-container {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: auto;

  border: 1px solid #eee;
  border-radius: 5px;
}

table {
  width: 100%;
  background-color: white;
}

th,
td {
  padding: 12px 10px;
  text-align: center !important;
}

th {
  position: sticky;
  top: 0;

  background: #fafafa;

  z-index: 1;
}

/* ESTATUS */

.estatus {
  display: inline-block;

  padding: 5px 12px;

  border-radius: 15px;

  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.estatus-ok {
  color: #087f23;
  background: #e8f5e9;
}

.estatus-error {
  color: #c62828;
  background: #ffebee;
}

.estatus-neutral {
  color: #555;
  background: #eeeeee;
}

/* SIN RESULTADOS */

.sin-resultados {
  height: 350px;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  color: #aaa;
}

.sin-resultados i {
  font-size: 50px;
}

.sin-resultados p {
  margin-top: 10px;
}

/* RESPONSIVE */

@media (max-width: 1100px) {

  .consulta-layout {
    grid-template-columns: 1fr;
  }

  .numeros-input {
    height: 250px;
  }

}

@media (max-width: 600px) {

  .resultados-header {
    flex-direction: column;
    align-items: stretch;
  }

  .busqueda-input {
    width: 100% !important;
  }

}

</style>